<!-- 异常类型Column -->
<template>
    <div>
        <el-tag v-if="row['excludeStatus'] === 0" type="success">{{ $t('integration.confirm_normal_msg') }}</el-tag>
        <el-tag v-else-if="row['excludeStatus'] === 1" type="info" style="background-color: #f4f4f5; color: #909399;">{{ $t('integration.confirm_abnormal_msg') }}</el-tag>
        <el-tag v-else-if="row['excludeStatus'] === 2" type="warning">
            {{ $t('integration.suspected_abnormal_msg') }}
        </el-tag>
        <span v-else></span>
    </div>
</template>

<script>
export default {
    props: ['row'],
    data() {
        return {

        }
    },
}
</script>
